const getDefaultState = () => ({
    currentProcess: null,
    currentSelectedDocuments: null,
    documentsCompanyProcessId: null,
    signCompletedDocIds: [],
    documentsIntendedRouteParam: null
});

export default {
    namespaced: true,
    state: getDefaultState(),

    getters: {
        // fetch any keys from vuex
        get: state => key => state[key],

        getCurrentProcess(state) {
            return state.currentProcess;
        },

        getCurrentSelectedDocuments(state) {
            return state.currentSelectedDocuments;
        },

        getDocumentsCompanyProcessId(state) {
            return state.documentsCompanyProcessId;
        },

        documentsIntendedRouteParam(state) {
            return state.documentsIntendedRouteParam;
        },

        getSignCompletedDocIds(state) {
            return state.signCompletedDocIds;
        }
    },

    mutations: {
        /**
         * 
         * @format data {
         *     key: key,
         *     value: value
         * }
         */
        SET_CURRENT_PROCESS(state, data) {
            state.currentProcess = data;
        },

        SET_CURRENT_SELECTED_DOCUMENTS(state, data) {
            state.currentSelectedDocuments = data;
        },

        SET_DOCUMENTS_COMPANY_PROCESS_ID(state, data) {
            state.documentsCompanyProcessId = data;
        },

        SET_DOCUMENTS_INTENDED_ROUTE_PARAMS(state, data) {
            state.documentsIntendedRouteParam = data;
        },

        SET_SIGN_COMPLETED_DOC(state, id) {
            state.signCompletedDocIds.push(id);  
        },

        CLEAR_SING_COMPLETED_DOC(state) {
            state.signCompletedDocIds = [];  
        },

        SET(state, data)
        {
            state[data.key] = data.value;
        },

        REMOVE(state, key)
        {
            state[key] = null;
        },

        CLEAR(state) 
        {
            if(Object.keys(this.state?.document).length) {
                Object.keys(this.state?.document).forEach(key => {
                    state[key] = null;
                });
            }
        }
    },
};
